var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldConditionsInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M10 1.66667C5.4 1.66667 1.66667 5.4 1.66667 10C1.66667 14.6 5.4 18.3333 10 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 10 1.66667ZM9.16667 5.83333V7.5H10.8333V5.83333H9.16667ZM9.16667 9.16667V14.1667H10.8333V9.16667H9.16667ZM3.33333 10C3.33333 13.675 6.325 16.6667 10 16.6667C13.675 16.6667 16.6667 13.675 16.6667 10C16.6667 6.325 13.675 3.33333 10 3.33333C6.325 3.33333 3.33333 6.325 3.33333 10Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#696F88"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldConditionsInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-conditions-info.2aa37024dc88dcb97c80cca949f2714c.svg";